const pie = {
  actionBlack: '#262626',
  actionBlackHover: '#373737',
  actionBlackActive: '#515151',
  actionDisabled: '#EFEDEA',
  actionBrand: '#F36805',
  actionBrandHover: '#E96405',
  actionBrandActive: '#D65C04',
  actionSecondary: '#F5F3F1',
  actionSecondaryHover: '#EBE9E7',
  actionSecondaryActive: '#D7D5D4',
  actionWhite: '#FFFFFF',
  actionWhiteHover: '#F5F3F1',
  actionWhiteActive: '#E0E0E0',
  backgroundDark: '#383838',
  contentDefault: '#242E30',
  contentBrand: '#F36805',
  contentDisabled: '#8C999B',
  contentError: '#D50525',
  contentInteractiveTertiary: '#303D3F',
  contentInteractiveSubdued: '#5D7074',
  contentSubdued: '#3C4C4F',
  contentLink: '#125FCA',
  contentPositive: '#017A39',
  contentWhite: '#FFFFFF',
  orange10: '#FFEAD4',
  orange30: '#ff8000',
  orange30Opacity50: '#ff800080',
  blackOpacity08: '#00000014',
  mozzarella30: '#DBD9D7',
  yellow: '#F6C243',
  secondaryHover: '#EBE9E7',
  secondaryActive: '#D7D5D4',
  lightOrange: '#FFE2C2',
  supportPositive2: '#E5FAEF',
  backgroundInteractive: '#262626',
  backgroundSubtle: '#F5F3F1',
  supportNeutral: '#EFEDEA',
  supportOrange: '#F75E28',
  borderInverse: '#575655',
  borderStrong: '#DBD9D7',
  borderForm: '#8B8A88',
  borderSelected: '#9E9C9A',
  brandSubtleHover: '#F5D9BA',
  brandSubtleActive: '#E0C7AB',
  contentPlaceholder: '#68797D',
  supportBrand03: '#c1dade',
  containerSubtle: '#f6f3ef',
  interactiveForm: '#797876',
  feedbackError: '#FFE9EA',
  newBackgroundSubtle: '#FCF8F5',

  payWithTouchHeroStart: '#FFF2E5',
  payWithTouchHeroMiddle: '#FDDFC3',
  payWithTouchHeroEnd: '#FFD3BF',

};

const colors = {
  primary: pie.orange30,
  primaryText: '#ffffff',

  secondary: '#0a3847',
  secondaryText: '#ffffff',

  background: '#f0f0f0',
  lightBackground: '#fafafa',
  lightBackground2: '#fcfcfc',
  darkBackground: '#f8f5f2',

  surface: '#ffffff',
  surfaceTitle: '#1574f5',
  surfacePrimaryAction: '#1574f5',
  surfacePrimaryActionDark: '#0953BD',
  surfacePrimaryActionLight: '#cfd8e4',
  surfacePrimaryActionText: '#ffffff',

  charcoal80: '#242E30',

  text: '#666666',
  text2: '#0A3847',

  gray000: '#000000',
  gray100: '#333333',
  gray200: '#666666',
  gray300: '#979797',
  gray500: '#D7D7D7',
  gray600: '#D8D8D8',
  gray700: '#E0DDD9',
  gray800: '#EBEBEB',
  gray900: '#F8F5F2',
  gray910: '#F5F5F5',
  gray920: '#F5F3F1',
  gray930: '#E4E4E4',
  gray950: '#A5A6A9',

  plate1: {color: '#fff', background: '#00b4db'},
  plate2: {color: '#00777f', background: '#dffdff'},
  plate3: {color: '#0371b5', background: '#f1f9ff'},
  plate4: {color: '#a15100', background: '#ffe8ca'},
  plate5: {color: '#1B7853', background: '#D9F6EB'},
  plate6: {color: '#ffc003', background: '#ffc003'},
  plate7: {color: '#cfd8e4', background: '#cfd8e4'},
  plate8: {color: '#275C7E', background: '#275C7E'},

  success: '#10d365',
  successDark: '#0ca74f',
  error: '#ff4246',
  info: '#00b4db',
  contrast: '#ff0',

  boxShadow: '#00000003',
  boxShadowLight: '#3f44610c',

  feedbackInfoRegular: '#205A6D',
  disclaimerSurface: '#FFECB3',
  ...pie,
};

export default colors;
